
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Perilunate_dislocation_stage',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Perilunate_dislocation_stage.vue